import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/portal',
    name: 'portal.home',
    component: () => import('./views/PortalHome.vue'),
    meta: { layout: 'portal', requiresAuth: true, requiresRole: 'cliente' },
  },
  {
    path: '/portal/casos/:id',
    name: 'portal.caso',
    component: () => import('./views/PortalCasoDetalle.vue'),
    props: true,
    meta: { layout: 'portal', requiresAuth: true, requiresRole: 'cliente' },
  },
]

export default routes
